import cn from 'classnames';
import styles from './ModalHeader.module.scss';

export const getClassNames = (className?: string) => {
  return cn(styles.header, className);
};
